<template>
  <div>
    <div v-if="$router.currentRoute.name === 'advanced-revenue-exclusion-periods'">
      <h1 class="mt-3 text-xs-center">Revenue Exclusion Periods</h1>

      <div class="layout row justify-end align-center pa-2">
        <v-btn color="primary" :to="{ name: 'advanced-revenue-exclusion-periods-period', params: { exclusionPeriodId: '0' } }">
          <v-icon left>fal fa-plus</v-icon>
          Create Exclusion Period
        </v-btn>
      </div>

      <v-layout row wrap px-2>
        <v-flex xs12 sm6 md2 pa-2>
          <v-select
            class="v-select--fixed-width"
            v-model="filters.agencyId"
            :items="agencyOptions"
            item-text="text"
            item-value="value"
            label="Agency"
            clearable
            dense
            hide-details
            :menu-props="{ offsetY: true }"
          />
        </v-flex>
        <v-flex xs12 sm6 md2 pa-2>
          <v-select
            class="v-select--fixed-width"
            v-model="filters.recurrenceType"
            :items="recurrenceTypeOptions"
            label="Recurrence"
            clearable
            dense
            hide-details
            :menu-props="{ offsetY: true }"
          />
        </v-flex>
        <v-flex xs12 sm6 md2 pa-2>
          <v-select
            class="v-select--fixed-width"
            v-model="filters.isActive"
            :items="activeStatusOptions"
            item-text="text"
            item-value="value"
            label="Status"
            dense
            hide-details
            :menu-props="{ offsetY: true }"
          />
        </v-flex>
        <v-flex xs12 sm6 md2 pa-2>
          <st-date-field
            id="revenue-exclusion-period-date-from"
            v-model="filters.dateFrom"
            label="Period From"
            hide-details
            to-date-id="revenue-exclusion-period-date-to"
          />
        </v-flex>
        <v-flex xs12 sm6 md2 pa-2>
          <st-date-field
            id="revenue-exclusion-period-date-to"
            v-model="filters.dateTo"
            label="Period To"
            hide-details
            from-date-id="revenue-exclusion-period-date-from"
          />
        </v-flex>
        <v-flex xs12 sm6 md2 pa-2>
          <v-text-field
            v-model="filters.searchKeywords"
            label="Search reason"
            hide-details
            append-icon="fal fa-search"
            clearable
          />
        </v-flex>
      </v-layout>

      <div class="layout row justify-end align-center px-2 mb-4">
        <v-btn flat small @click="resetFilters" :disabled="apiInProgress">Reset</v-btn>
        <v-btn fab small @click="onApplyFilters" :disabled="apiInProgress">
          <v-icon>fal fa-filter</v-icon>
        </v-btn>
      </div>

      <v-data-table
        :headers="headers"
        :items="records"
        :pagination.sync="pagination"
        :total-items="totalRecords"
        :loading="apiInProgress"
        :rows-per-page-items="[10, 25, 50]"
        @update:pagination="onPagination"
        must-sort
      >
        <template v-slot:items="{ item }">
          <tr class="clickable-row" @click="openRecord(item)">
            <td>{{ item.agencyId || '-' }}</td>
            <td>{{ formatRecurrenceType(item.recurrenceType) }}</td>
            <td>{{ formatPattern(item) }}</td>
            <td>{{ item.reason || '-' }}</td>
            <td>{{ item.isActive ? 'Active' : 'Inactive' }}</td>
            <td>{{ formatDateTime(item.dateUpdated) }}</td>
          </tr>
        </template>
      </v-data-table>
    </div>

    <router-view :signed-in-user="signedInUser" />
  </div>
</template>

<script>
import src from './src'

export default src
</script>

<style scoped>
.clickable-row {
  cursor: pointer;
}

.clickable-row:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
</style>
